export default __webpack_public_path__ + "static/media/twitter.1d2c2484.svg";